import { useFlag } from '@/features/unleash';
import { FeedCardHeader } from './FeedCardHeader';
import { FeedCardHeaderDeprecated } from './FeedCardHeaderDeprecated';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof FeedCardHeader> &
  ComponentProps<typeof FeedCardHeaderDeprecated>;

export const FlaggedFeedCardHeader = (props: Props) => {
  const { enabled, flagsReady } = useFlag({ name: 'mono-narrative-feed-fv' });

  if (enabled && flagsReady) {
    return <FeedCardHeader {...props} />;
  }
  return <FeedCardHeaderDeprecated {...props} />;
};
